import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hovered"];
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import { useCallback, useState } from 'react';
import FileAttachment from '../files/FileAttachment';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useProperty } from '../v2/hooks/useProperty';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { useHovered } from 'foundations-components/transitional/utils/useHovered';
import { Flex } from 'foundations-components/components/Flex';
import { Popover, PopoverBody, PopoverCloseButton } from 'foundations-components/transitional/components/Popover';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertyInputFilesWrapper = ({
  input,
  fileReferences,
  popoverProps,
  onOpenChange
}) => {
  const _useHovered = useHovered({}),
    {
      hovered
    } = _useHovered,
    hoveredProps = _objectWithoutPropertiesLoose(_useHovered, _excluded);
  const [showPopover, setShowPopover] = useState(true);
  const value = usePropertyValue();
  const parsedValues = parseMultiEnumValue(value);
  const property = useProperty();
  const firstReference = fileReferences && fileReferences.find(reference => reference.id === parsedValues[0]);
  const moreText = parsedValues.length > 1 ? /*#__PURE__*/_jsx(Text, {
    color: "text-core-subtle",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputFilesV2.more",
      options: {
        count: parsedValues.length - 1
      }
    })
  }) : null;
  const handleOpenChange = useCallback(evt => {
    onOpenChange === null || onOpenChange === void 0 || onOpenChange(evt);
    setShowPopover(evt.target.value);
  }, [onOpenChange]);
  const handleClick = useCallback(() => {
    setShowPopover(prev => !prev);
  }, []);
  const fileValue = firstReference ? /*#__PURE__*/_jsx(FileAttachment, {
    fileReference: firstReference
  }) : EMPTY_PROPERTY_VALUE;
  const manageButton = /*#__PURE__*/_jsx(Flex, {
    flexShrink: "0",
    children: hovered ? /*#__PURE__*/_jsx(Button, {
      use: "tertiary-light",
      size: "extra-small",
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.PropertyInputFilesV2.manageButton"
      })
    }) : moreText
  });
  return /*#__PURE__*/_jsx(Popover, Object.assign({
    inlineSize: "350px",
    placement: "right"
  }, popoverProps, {
    open: showPopover,
    content: /*#__PURE__*/_jsxs(PopoverBody, {
      paddingBlockEnd: "500",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "start",
        justifyContent: "space-between",
        marginBlockEnd: "100",
        children: [/*#__PURE__*/_jsxs(Text, {
          as: "h6",
          children: [property.label, " (", parsedValues.length, ")"]
        }), /*#__PURE__*/_jsx(PopoverCloseButton, {
          onClick: () => setShowPopover(false)
        })]
      }), input]
    }),
    onOpenChange: handleOpenChange,
    "data-test-id": "property-input-files-popover",
    children: /*#__PURE__*/_jsxs(Flex, Object.assign({
      alignItems: "center"
    }, hoveredProps, {
      children: [fileValue, manageButton]
    }))
  }));
};
export default PropertyInputFilesWrapper;